window.addEventListener('load', function () {
  jQuery(function ($) {
    const $slider = $('.zendesk-testimonial-slider');
    if (!$slider.length) return;
    $slider.slick({
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      variableWidth: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 7000,
      pauseOnHover: true,
      arrows: false,
      dots: false,
    });
  });
});
